import DropDown from './components/Dropdown.vue'
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import DownloadLinksMenu from './components/DownloadLinksMenu.vue';
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component('drop-down', DropDown);
    Vue.component('moon-loader', MoonLoader);
    Vue.component('download-links-menu', DownloadLinksMenu);
  }
}

export default GlobalComponents
